import { useViewport } from 'reactflow';

import { CreateNodeFloatingMenuButton, CreateNodeShortcutCommand, RoundedPlus } from '@/react_app/components';
import { ExtendedReactElement } from '@/utils/types';

export const EdgePlusButton = ({
	isMoveNodeActive = false,
	className,
	onPlusClick,
	setIsFloatingMenuOpen,
	style,
	floatingMenuEnabled,
}: ExtendedReactElement<{
	isMoveNodeActive?: boolean;
	onPlusClick: (shortcut?: CreateNodeShortcutCommand) => void;
	scale: number;
	setIsFloatingMenuOpen?: (open: boolean) => void;
	floatingMenuEnabled?: boolean;
}>) => {
	const { zoom } = useViewport();
	return (
		<>
			{isMoveNodeActive ? (
				<RoundedPlus className={className} isMoveNodeActive={isMoveNodeActive} onClick={() => onPlusClick()} />
			) : floatingMenuEnabled ? (
				<CreateNodeFloatingMenuButton onShortcutClick={onPlusClick} scale={zoom} setIsOpen={setIsFloatingMenuOpen}>
					<RoundedPlus className={className} style={style} />
				</CreateNodeFloatingMenuButton>
			) : (
				<RoundedPlus className={className} style={style} onClick={() => onPlusClick()} />
			)}
		</>
	);
};

export type OnPlusClick = Parameters<typeof EdgePlusButton>[0]['onPlusClick'];
